const DARK_FALLBACK = "#0A0A0A";

function hexLuminance(hex) {
	if (typeof hex !== "string") return 1;
	const h = hex.replace("#", "").trim();
	if (h.length !== 6) return 1;
	const r = parseInt(h.slice(0, 2), 16);
	const g = parseInt(h.slice(2, 4), 16);
	const b = parseInt(h.slice(4, 6), 16);
	if ([r, g, b].some((n) => Number.isNaN(n))) return 1;
	return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

export function isLightBackground(hex) {
	return hexLuminance(hex) > 0.45;
}

const WHITE = "#FFFFFF";

function isNearWhite(hex) {
	return hexLuminance(hex) > 0.93;
}

/** Preview QA: `?mood=oscuro` fuerza el fondo del onboarding oscuro. */
export function getMoodOverride() {
	if (typeof window === "undefined") return null;
	const mood = new URLSearchParams(window.location.search).get("mood");
	return mood === "oscuro" ? "oscuro" : null;
}

/**
 * - mood oscuro → fondo negro si el guardado es claro
 * - resto → los off-white (#fffafa, #f9f6f0…) se leen como verde/crema
 *   junto al color de marca; se normalizan a blanco
 */
export function resolvePageBackground(backgroundColor, mood) {
	if (mood === "oscuro") {
		if (!backgroundColor || isLightBackground(backgroundColor)) {
			return DARK_FALLBACK;
		}
		return backgroundColor;
	}
	if (backgroundColor && isNearWhite(backgroundColor)) {
		return WHITE;
	}
	return backgroundColor || null;
}
